module.exports = __webpack_public_path__ + "static/img/50000Pkg.22549ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/50000Pkg.png
// module id = crFb
// module chunks = 0